import React, { Component } from 'react';

class EntityValueInput extends Component {
  static defaultProps = {
    bringValueToParents : () => {
      console.error("EntityValueInput.props.bringValueToParents is undefined");
    }
  }

  state = {
    value : "",
  }

  handleValueOnChange = (e) => {
    const { value } = e.target;

    this.setState({
      value : value,
    })
  }

  handleValueOnKeyPress = (e) => {
    const { key } = e;
    if (key === "Enter") {
      const { bringValueToParents } = this.props;
      const { value } = this.state;
      bringValueToParents(value);
      // initialize this state
      this.setState({
        value : "",
      })
    }
  }

  initializeState = () => {
    this.setState({
      value : "",
    })
  }

  render() { 

    const { handleValueOnChange } = this;
    const { handleValueOnKeyPress } = this;
    const { value } = this.state;

    return (
      <input type="text" className="entity-value-input" placeholder="값 입력"
        value={value}
        onChange={handleValueOnChange}
        onKeyPress={handleValueOnKeyPress} />
    );
  }
}
 
export default EntityValueInput;